<button class="btn btn-close close" (click)="closeWindow()"></button>
<div class="main-content">

  @if (isLoading) {
    <div class="col-12 loader-wrapper">
      <div class="loader"></div>
    </div>
  } @else {
    @if (errorGettingPageImg) {
      <div class="error-message">
        <h4 class="mb-5">Error retrieving original document for display.
          @if (model?.originalFileUrl) {
            <span>Try downloading the document directly.</span>
          }
        </h4>
        @if (model?.originalFileUrl) {
          <a class="btn btn-empty-primary" target="_blank"
            href="{{model.originalFileUrl}}">
            <i class="fas fa-download"></i> Download Document
          </a>
        }
      </div>
    } @else {
      <div class="toolbar row">
        <div class="left-content col">
          <h5 class="float-start mb-0">
            <strong class="fs-block">{{ model.jobPayload.company.name }}</strong>
            <span class="text-muted separator"> | </span>
            <span class="text-muted document-name" data-bs-toggle="tooltip" data-bs-placement="bottom" [title]="model.jobPayload.documentFile.originalDocumentName" appFsMask>{{ model.jobPayload.documentFile.originalDocumentName }}</span>
          </h5>
        </div>
        <div class="center-content col">
          <app-pdf-paginator [pageCount]="pageCount"></app-pdf-paginator>
          <div class="btn-separator">|</div>
          <app-pdf-zoom [zoomElementContainerId]="showTable ? 'page-table-list' : 'page-img-list'"></app-pdf-zoom>
        </div>
        <div class="right-content col">
          <a [ngClass]="{'disabled': isLoading}" class="btn btn-empty-primary float-end" target="_blank"
            href="{{model.originalFileUrl}}"><i class="fas fa-download"></i>Download Document</a>
          </div>
        </div>
        <div class="page-content-container fs-block" #docContainer (scroll)="handleScroll()">
          <div class="doc-container">
            @if (!showTable) {
              <ul id="page-img-list" class="page-images">
                @for (pageUrl of safePageImgUrls; track pageUrl; let i = $index) {
                  <li class="page-img-list-item" #pageImgListItem
                    >
                    <img [src]="pageUrl">
                  </li>
                }
              </ul>
            }
            @if (showTable) {
              <div id="page-table-list">
                @for (page of model.document.pages; track page) {
                  <table class="excel-table"
                    #pageImgListItem>
                    @for (row of page.cells; track row) {
                      <tr>
                        @for (col of row; track col) {
                          <td>{{ col.text }}</td>
                        }
                      </tr>
                    }
                  </table>
                }
              </div>
            }
          </div>
        </div>
      }
    }

  </div>
